<template>
    <div class="image-list" v-if="data.length" @touchmove.stop.prevent>
        <sd-swiper :num="data.length" :index.sync="picIndex" class="content">
            <div class="pic swiper-content" v-for="(item, index) in data" :key="index">
                <zoom class="image-zoom" v-if="item.type == 'pic'" :src="item.path"></zoom>
                <!-- <template v-if="item.type == 'pic'">
                    <img :src="item.path" />
                </template> -->

                <template v-else-if="item.type == 'video'">
                    <video :ref="item.videoKey" :src="item.videoPath" :poster="item.path" :controls="showControls" controlslist="nodownload nofullscreen noremoteplayback noplaybackrate" disablePictureInPicture ></video>
                    <img class="play" v-show="!isPlay" src="@/assets/img/play.png" @click.stop="startPaly(item)" />
                </template>
            </div>
        </sd-swiper>

        <div class="pre pnbutton" v-show="picIndex != 0" @click="changeIndex(-1)"><svg-icon icon-class="arrow"></svg-icon></div>
        <div class="next pnbutton" v-show="picIndex != data.length-1" @click="changeIndex(1)"><svg-icon icon-class="arrow"></svg-icon></div>

        <!-- <div class="content" :style="`width: ${100*data.length}vw; left: ${moveX}px; transform: translateX(${-100*contentIndex}vw);`"  @touchstart="start" @touchmove="move" @touchend="end">
            <div class="pic" v-for="(item, index) in data" :key="index">
                <template v-if="item.type == 'pic'">
                    <img :src="item.path" />
                </template>

                <template v-else-if="item.type == 'video'">
                    <video :ref="item.videoKey" :src="item.videoPath" :poster="item.path" :controls="showControls" controlslist="nodownload nofullscreen noremoteplayback noplaybackrate" disablePictureInPicture ></video>
                    <img class="play" v-show="!isPlay" src="@/assets/img/play.png" @click.stop="startPaly(item)" />
                </template>
            </div>
        </div> -->
        <template>
            <div class="close" @click="$emit('update:list', [])"><img src="@/assets/img/close2.png" /></div>
            <!-- <div class="save">Save Picture</div> -->
            <div class="mark">{{picIndex+1}} / {{data.length}}</div>
        </template>
    </div>
</template>

<script>
import sdSwiper from "../common/swiperContent.vue";
import SvgIcon from '../svgIcon.vue';
import zoom from './zoom.vue';

export default {
    name: "image-list",
    props: {
        list: Array
    },
    components: { sdSwiper, SvgIcon, zoom },
    data() {
        return {
            isPlay: false, // 是否在播放
            showControls: false,

            video: null,

            picIndex: 0
        }
    },
    computed: {
        data() {
            this.picIndex = 0;
            return this.list;
        },
    },
    watch: {
        picIndex(val) {
            if(val != 0) {
                this.pause()
            }else {

            }
        },
    },
    mounted() {
        if(this.list[0] && this.list[0].type == 'video') {
            this.startPaly(this.list[0]);
        }
    },
    methods: {
        getVideoItem(item) {
            return this.$refs[item.videoKey] ? this.$refs[item.videoKey][0] : null;
        },

        startPaly(item) {
            this.video = this.getVideoItem(item);
            this.video.addEventListener("pause", this.pause)
            this.video.play().catch((err) => {
              console.log(err);
              this.isPlay = false;
              this.showControls = false;
            });
            this.isPlay = true;
            this.showControls = true;
        },

        videoClick(item) {
            if(this.timeOut) {

            }else {
                this.timeOut = setTimeout(() => {
                    this.showPauseIcon = true;
                }, 3000);
            }
        },

        pause() {
          try {
            this.video.pause();
            this.isPlay = false;
            this.showControls = false;
          } catch (error) {
            console.log(error);
          }

        },

        changeIndex(num) {
            this.picIndex = this.picIndex + num;
        }
    }
}
</script>

<style lang="scss" scoped>
.image-list {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: black;
    z-index: 99;
    color: white;

    .content {
        height: 100%;
        overflow: hidden;

        .pic {
            height: 100%;
            width: 100%;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                object-fit: contain;
            }

            video {
                width: 100%;
            }

            .play {
                width: 67px;
                height: 67px;
                position: absolute;
                top: calc(50% - 33.5px);
                left: calc(50% - 33.5px);
            }

            .swiper-content {
                width: 100vw;

                .image-zoom {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .close {
        position: absolute;
        top: 24px;
        left: 20px;
        width: 32px;
        height: 32px;
    }

    .save {
        position: absolute;
        bottom: 24px;
        left: 12px;
        line-height: 40px;
        background: rgba(255, 255, 255, 0.2);
        padding: 0 20px;
        border-radius: 20px;
    }

    .mark {
        position: absolute;
        bottom: 33px;
        right: 20px;
    }

    .pnbutton {
        position: absolute;
        top: calc(50% - 20px);
        left: 12px;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: rgba(1,1,1,0.1);

        &.next {
            left: auto;
            right: 12px;
            transform: rotate(180deg);
        }

        .arrow {
            color: white;
            position: relative;
            transform: rotate(90deg);
            left: -1px;
            top: 2px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/base/images.vue